<template>
  <div class="card">
    <div class="applicant-advance-filter" layout="column">
      <div class="mb-x3" layout>
        <div class="search-form mr-x1" layout="column">
          <div class="label mb-x1">{{ accountName.label }}</div>
          <el-input
            type="text"
            v-model="accountName.value"
            @change="accountName.onChange"
            :placeholder="accountName.placeholder"
          >
            <template slot="prepend"><i class="mdi mdi-magnify"></i></template>
          </el-input>
        </div>
        <select-form
          :label="isJoinDatetime.label"
          :icon="isJoinDatetime.icon"
          :value="isJoinDatetime.value"
          :options="isJoinDatetime.options"
          :onChange="isJoinDatetime.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isProfileImage.label"
          :icon="isProfileImage.icon"
          :value="isProfileImage.value"
          :options="isProfileImage.options"
          :onChange="isProfileImage.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isDescription.label"
          :icon="isDescription.icon"
          :value="isDescription.value"
          :options="isDescription.options"
          :onChange="isDescription.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isNewFollower.label"
          :icon="isNewFollower.icon"
          :value="isNewFollower.value"
          :options="isNewFollower.options"
          :onChange="isNewFollower.onChange"
          clearable
        ></select-form>
      </div>
      <div class="mb-x3" layout>
        <div class="date-range-form" layout="column">
          <div class="label mb-x1">応募期間</div>
          <AppDateRangePicker
            :value="entryDateRange.value"
            :campaign="campaign"
            :campaign-prize="campaignPrize"
            @change="onDateRangeChange"
            :placeholder="['開始日時', '終了日時']"
            size="small"
            :clearable="false"
          />
        </div>
      </div>
      <div class="mb-x3" layout>
        <select-form
          :label="isPositive.label"
          :icon="isPositive.icon"
          :value="isPositive.value"
          :options="isPositive.options"
          :onChange="isPositive.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isWarning.label"
          :icon="isWarning.icon"
          :value="isWarning.value"
          :options="isWarning.options"
          :onChange="isWarning.onChange"
          clearable
        ></select-form>
        <select-form
          :label="postType.label"
          :icon="postType.icon"
          :value="postType.value"
          :options="postType.options"
          :onChange="postType.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isMedia.label"
          :icon="isMedia.icon"
          :value="isMedia.value"
          :options="isMedia.options"
          :onChange="isMedia.onChange"
          clearable
        ></select-form>
        <select-form
          :label="isSuspendedAccount.label"
          :icon="isSuspendedAccount.icon"
          :value="isSuspendedAccount.value"
          :options="isSuspendedAccount.options"
          :onChange="isSuspendedAccount.onChange"
          clearable
        ></select-form>
      </div>
      <div class="mb-x3" layout layout-align="start-center">
        <input-range-form
          label="フォロワー数"
          :value="followersCount.value"
          @input="changeFollowersCount"
        ></input-range-form>
        <input-range-form label="FF比率" :value="followsRate.value" @input="changeFollowsRate"></input-range-form>
        <input-range-form label="ポスト数" :value="tweetsCount.value" @input="changeTweetsCount"></input-range-form>
      </div>
      <div class="mb-x3" layout layout-align="start-center">
        <input-range-form label="応募数" :value="postsCount.value" @input="changePostsCount"></input-range-form>
        <input-range-form
          v-if="campaignAccountId"
          label="累計参加数"
          :value="totalCampaignEntryCount.value"
          @input="changeTotalCampaignEntryCount"
        ></input-range-form>
        <input-range-form
          v-if="campaignAccountId"
          label="累計当選数"
          :value="totalCampaignWinningCount.value"
          @input="changeTotalCampaignWinningCount"
        ></input-range-form>
      </div>
      <div class="hunter-switch" layout>
        <el-switch
          v-model="isCheckHunterAccount"
          active-text="懸賞アカウントを除外する"
          @change="changeSwitchEvent('isCheckHunterAccount')"
        ></el-switch>
        <el-tooltip placement="top" content="懸賞が主目的のアカウントを自動判定し、該当する場合は非表示とします。"
          ><i class="mdi mdi-help-circle ml-x1"></i
        ></el-tooltip>
      </div>
      <div v-if="isCheckHunterAccount" class="hunter-filter" layout>
        <div>
          <span>フィルタリング強度</span>
          <el-tooltip placement="top">
            <template v-slot:content
              >懸賞アカウントの判定基準となるフィルタリングの強さを設定できます。<br />「強」に近づくほど、抽選対象に含まれる懸賞アカウントの割合が下がります。</template
            >
            <template v-slot:default><i class="mdi mdi-help-circle ml-x1"></i></template>
          </el-tooltip>
        </div>
        <div class="slider-labels">
          <span>弱</span>
          <el-slider v-model="hunterFilteringStrength" :min="1" :max="8" :step="1" @input="onSliderChange"></el-slider
          ><span>強</span>
        </div>
      </div>
      <div layout layout-align="start-center">
        <el-button type="primary" @click="changeAdvanceFilter" :disabled="isLoading"
          ><i class="mdi mdi-plus"></i>詳細条件を追加して検索</el-button
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.search-form {
  .el-input {
    width: $spacing-unit * 37;
  }
}

.select-form {
  margin-right: $spacing-unit;
}

:deep(.el-input__inner) {
  height: $spacing-unit * 4;
}

:deep(.el-input) {
  width: $spacing-unit * 18;
}

.slider-labels {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 23%;
}

.slider-labels span {
  width: 20px;
  text-align: center;
}

.el-slider {
  flex-grow: 0;
  width: 100%;
  margin: 0 20px;
}

.hunter-filter {
  display: block;
  margin-bottom: $spacing-unit * 2;
}

.hunter-switch {
  margin-bottom: $spacing-unit * 2;
}

.date-range-form {
  display: flex;
  flex-direction: column;

  .el-date-editor {
    width: $spacing-unit * 45;

    .el-range-separator {
      width: auto;
      padding: 0 5px;
      line-height: 32px;
    }
  }
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import { AppDateRangePicker } from '@/client/components/_atoms'
import InputRangeForm from '@/client/components/_atoms/input_range_form'
import SelectForm from '@/client/components/_atoms/select_form'
import { TrackingService } from '@/client/services'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'

export default defineComponent({
  components: {
    SelectForm,
    InputRangeForm,
    AppDateRangePicker
  },
  created() {
    this.accountName.value = this.params.accountName
    this.isJoinDatetime.value = this.params.isJoinDatetime
    this.isProfileImage.value = this.params.isProfileImage
    this.isDescription.value = this.params.isDescription
    this.isNewFollower.value = this.params.isNewFollower
    this.isPositive.value = this.params.isPositive
    this.isWarning.value = this.params.isWarning
    this.isSuspendedAccount.value = this.params.isSuspendedAccount
    this.postType.value = this.params.postType
    this.isMedia.value = this.params.isMedia
    this.followersCount.value = this.params.followersCount
    this.followsRate.value = this.params.followsRate
    this.tweetsCount.value = this.params.tweetsCount
    this.postsCount.value = this.params.postsCount
    this.totalCampaignEntryCount.value = this.params.totalCampaignEntryCount
    this.totalCampaignWinningCount.value = this.params.totalCampaignWinningCount
    // 既存のパラメータがある場合はそれを使用
    if (this.params.entryDateFrom || this.params.entryDateTo) {
      this.entryDateRange.value = [this.params.entryDateFrom || '', this.params.entryDateTo || '']
    } else {
      // デフォルト値は空にしておく（AppDateRangePickerで設定）
      this.entryDateRange.value = ['', '']
    }
  },
  data() {
    return {
      // アカウント名検索
      accountName: {
        value: '',
        label: 'アカウント名検索',
        placeholder: '検索(完全一致)',
        onChange: (value: string) => {
          TrackingService.sendEvent('input:応募一覧（X）|アカウント名検索')

          this.accountName.value = value
        }
      },
      // 新規獲得フォロワー
      isNewFollower: {
        value: '',
        label: '新規獲得フォロワー',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '獲得フラグあり',
            value: 1
          },
          {
            label: '獲得フラグなし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|新規獲得フォロワー')

          this.isNewFollower.value = value
        }
      },
      // ポスト種別
      postType: {
        value: '',
        label: 'ポスト種別',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'ポスト',
            value: 'tweet'
          },
          {
            label: '公式リポスト',
            value: 'retweet'
          },
          {
            label: '引用',
            value: 'quote_tweet'
          },
          {
            label: 'メンション',
            value: 'mention'
          },
          {
            label: '返信',
            value: 'reply'
          }
        ],
        onChange: (value: string) => {
          TrackingService.sendEvent('select:応募一覧（X）|ポスト種別')

          this.postType.value = value
        }
      },
      // メディア
      isMedia: {
        value: '',
        label: 'メディア',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'メディアあり',
            value: 1
          },
          {
            label: 'メディアなし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|メディア')

          this.isMedia.value = value
        }
      },
      // ネガティブ判定
      isWarning: {
        value: '',
        label: 'ネガティブ判定',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '判定あり',
            value: 1
          },
          {
            label: '判定なし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|ネガティブ判定')

          this.isWarning.value = value
        }
      },
      // ポジティブ判定
      isPositive: {
        value: '',
        label: 'ポジティブ判定',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '判定あり',
            value: 1
          },
          {
            label: '判定なし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|ポジティブ判定')

          this.isPositive.value = value
        }
      },
      // アカウント開設日
      isJoinDatetime: {
        value: '',
        label: 'アカウント開設日',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'キャンペーン開始より前',
            value: 1
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|アカウント開設日')

          this.isJoinDatetime.value = value
        }
      },
      // プロフィール画像
      isProfileImage: {
        value: '',
        label: 'プロフィール画像',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '設定あり',
            value: 1
          },
          {
            label: '設定なし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|プロフィール画像')

          this.isProfileImage.value = value
        }
      },
      // 自己紹介
      isDescription: {
        value: '',
        label: '自己紹介',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '入力あり',
            value: 1
          },
          {
            label: '入力なし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|自己紹介')

          this.isDescription.value = value
        }
      },
      // フォロワー数
      followersCount: {
        value: ['', '']
      },
      // FF比率
      followsRate: {
        value: ['', '']
      },
      // ポスト数
      tweetsCount: {
        value: ['', '']
      },
      // 応募数
      postsCount: {
        value: ['', '']
      },
      // 累計参加数
      totalCampaignEntryCount: {
        value: ['', '']
      },
      // 累計当選数
      totalCampaignWinningCount: {
        value: ['', '']
      },
      // 応募期間
      entryDateRange: {
        value: ['', '']
      },
      tempStartDate: null,

      // 凍結アカウント
      isSuspendedAccount: {
        value: '',
        label: '凍結フラグ',
        icon: '',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '凍結フラグあり',
            value: 1
          },
          {
            label: '凍結フラグなし',
            value: 0
          }
        ],
        onChange: (value: string | number) => {
          TrackingService.sendEvent('select:応募一覧（X）|凍結フラグ')

          this.isSuspendedAccount.value = value
        }
      },

      isCheckHunterAccount: false,
      hunterFilteringStrength: 5
    }
  },
  computed: {
    ...mapState(useTwitterApplicantStore, {
      params: state => state.params,
      campaign: state => state.campaign,
      campaignPrize: state => state.campaignPrize,
      campaignAccountId: state => (state.campaign && state.campaign.account ? state.campaign.account.id : ''),
      isLoading: state => state.isLoading
    })
  },
  methods: {
    ...mapActions(useTwitterApplicantStore, ['setParams', 'fetchApplicants']),
    changeFollowersCount(val: number[]) {
      if (this.followersCount.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|フォロワー数|以上')
      } else if (this.followersCount.value[1] !== val[1])
        TrackingService.sendEvent('input:応募一覧（X）|フォロワー数|未満')

      this.followersCount.value = val
    },
    changeFollowsRate(val: number[]) {
      if (this.followsRate.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|FF比率|以上')
      } else if (this.followsRate.value[1] !== val[1]) TrackingService.sendEvent('input:応募一覧（X）|FF比率|未満')

      this.followsRate.value = val
    },
    changeTweetsCount(val: number[]) {
      if (this.tweetsCount.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|ポスト数|以上')
      } else if (this.tweetsCount.value[1] !== val[1]) TrackingService.sendEvent('input:応募一覧（X）|ポスト数|未満')

      this.tweetsCount.value = val
    },
    changePostsCount(val: number[]) {
      if (this.postsCount.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|応募数|以上')
      } else if (this.postsCount.value[1] !== val[1]) TrackingService.sendEvent('input:応募一覧（X）|応募数|未満')

      this.postsCount.value = val
    },
    changeTotalCampaignEntryCount(val: number[]) {
      if (this.totalCampaignEntryCount.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|累計参加数|以上')
      } else if (this.totalCampaignEntryCount.value[1] !== val[1])
        TrackingService.sendEvent('input:応募一覧（X）|累計参加数|未満')

      this.totalCampaignEntryCount.value = val
    },
    changeTotalCampaignWinningCount(val: number[]) {
      if (this.totalCampaignWinningCount.value[0] !== val[0]) {
        TrackingService.sendEvent('input:応募一覧（X）|累計当選数|以上')
      } else if (this.totalCampaignWinningCount.value[1] !== val[1])
        TrackingService.sendEvent('input:応募一覧（X）|累計当選数|未満')

      this.totalCampaignWinningCount.value = val
    },
    async changeAdvanceFilter() {
      TrackingService.sendEvent('click:応募一覧（X）|詳細条件を追加して検索')

      const params: {
        accountName: string
        isJoinDatetime: boolean
        isProfileImage: boolean
        isDescription: boolean
        isNewFollower: boolean
        isPositive: boolean
        isWarning: boolean
        postType: string
        isMedia: boolean
        isSuspendedAccount: boolean
        followersCount: number
        followsRate: number
        tweetsCount: number
        postsCount: number
        totalCampaignEntryCount: number
        totalCampaignWinningCount: number
        hunterPoint?: number | null
        entryDateFrom?: string
        entryDateTo?: string
      } = {
        accountName: this.accountName.value,
        isJoinDatetime: this.isJoinDatetime.value,
        isProfileImage: this.isProfileImage.value,
        isDescription: this.isDescription.value,
        isNewFollower: this.isNewFollower.value,
        isPositive: this.isPositive.value,
        isWarning: this.isWarning.value,
        postType: this.postType.value,
        isMedia: this.isMedia.value,
        isSuspendedAccount: this.isSuspendedAccount.value,
        followersCount: this.followersCount.value,
        followsRate: this.followsRate.value,
        tweetsCount: this.tweetsCount.value,
        postsCount: this.postsCount.value,
        totalCampaignEntryCount: this.totalCampaignEntryCount.value,
        totalCampaignWinningCount: this.totalCampaignWinningCount.value
      }

      // 応募期間を追加
      if (this.entryDateRange.value[0]) {
        params.entryDateFrom = this.entryDateRange.value[0]
      }
      if (this.entryDateRange.value[1]) {
        params.entryDateTo = this.entryDateRange.value[1]
      }

      if (this.isCheckHunterAccount) {
        params.hunterPoint = this.getHunterPoint(this.hunterFilteringStrength)
      } else params.hunterPoint = null

      await this.setParams(params)

      await this.fetchApplicants()
    },
    onDateRangeChange(value: string[] | null) {
      TrackingService.sendEvent('select:応募一覧（X）|応募期間')
      this.entryDateRange.value = value || ['', '']
    },
    changeSwitchEvent() {
      TrackingService.sendEvent('click:応募一覧（X）|懸賞アカウントを除外する')
    },
    /**
     * 懸賞フィルタ強度を懸賞ポイントに変換
     */
    getHunterPoint(hunterFilteringStrength: number): number {
      switch (hunterFilteringStrength) {
        case 8:
          return -3
        case 7:
          return -2
        case 6:
          return -1
        case 5:
          return 0
        case 4:
          return 1
        case 3:
          return 2
        case 2:
          return 3
        case 1:
          return 4
        default:
          return 4
      }
    },
    onSliderChange() {
      TrackingService.sendEvent('slide:応募一覧（X）|フィルタリング強度')
    }
  }
})
</script>
